import { Container, Divider } from '@mui/material';
import BetaDisclaimer from './BetaDisclaimer';

export default function AppFooter() {
  return (
    <Container
      component="footer"
      maxWidth={false}
      sx={{ mt: 'auto', pt: 5, pb: 3, px: 2, width: '100%' }}
    >
      <Divider sx={{ mb: 3 }} />
      <BetaDisclaimer />
    </Container>
  );
}
